import React from "react";

class CheckoutReceipt extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentCheckout: JSON.parse(localStorage.getItem('currentCheckout')),
            currentUser: localStorage.getItem('username')
        };
    }

    componentDidMount() {
        var Products = [];
        var harga = [];
        var qty = [];
        var total = 0;
        this.state.currentCheckout?.transaction && this.state.currentCheckout.transaction.filter(transaction => transaction).map((transaction) => {
            Products.push(transaction.product_name);
            total += transaction.final_sell_price;
            harga.push(Number(transaction.final_sell_price).toLocaleString());
            qty.push(transaction.product_stock);
        })
        console.log(harga)
        var stringJs = "     Sugity Creatives";
        stringJs += "\n          SC Mart";
        stringJs += "\n";
        stringJs += "\nNik : " + (this.state.currentCheckout.nik !== 0 ? this.state.currentCheckout.nik : '-');
        stringJs += "\nStatus : " + (Number(this.state.currentCheckout?.paymentMethod) === 2 ? 'Cashbon' : 'Cash');
        stringJs += "\nKasir : " + (this.state.currentUser); 
        stringJs += "\n-------------------------------";
        stringJs += "\nQty   Product";
        var maxProdLength = Products[0].length;
        var maxQtyLength = qty[0].toString().length;

        for (var i = 0; i < Products.length; i++) {
            if (maxProdLength < Products[i].length) {
                maxProdLength = Products[i].length;
            }
        }

        for (var i = 0; i < qty.length; i++) {
            if (maxQtyLength < qty[i].toString().length) {
                maxQtyLength = qty[i].toString().length;
            }
        }

        // max product length cannot more than 13
        if (maxProdLength >= 13) {
            maxProdLength = 13;
        }

        var spaces = "    ";
        console.log((maxProdLength - 7) + 2)
        for (var i = 0 ; i < (maxProdLength - 7) + 2 ; i++) {
            spaces += " ";
        }
        
        stringJs += spaces + "Price";
        stringJs += "\n-------------------------------";

        var totalPrices = Number(total).toLocaleString();
        for (var i = 0; i < Products.length; i++) {
            spaces = "     ";
            if (Products[i].length < maxProdLength) {
                for (var j = 0 ; j < maxProdLength - Products[i].length ; j++) {
                    spaces += " ";
                }
            }
            var qSpaces = ""
            if (qty[i].toString().length > 1) {
                for (var j = 0 ; j < 6 - qty[i].toString().length ; j++) {
                    qSpaces += " ";
                }
            } else {
                qSpaces += "     ";
            }

            var pname = Products[i]
            if (Products[i].length >= 13) {
                pname = Products[i].substring(0, 13);
            }
            stringJs += `\n`+qty[i] + qSpaces + pname + spaces + harga[i] ;
        }
        stringJs += "\n-------------------------------"

        // generate total space based on max length product
        var totSpaces = "";
        for (var i = 0 ; i < maxProdLength - 7 ; i++) {
            totSpaces += " ";
        }
        stringJs += "\nTotal : " + totalPrices;
        stringJs += "\n";
        stringJs += "\nDate : " + (new Date().toLocaleDateString()
                                         + ' ' + new Date().toLocaleTimeString());

        var x = document.createElement("PRE");
        var t = document.createTextNode(stringJs);
        x.appendChild(t);
        document.body.appendChild(x);
    }

    handlePrint() {
        window.print();
    }

    render() {
        return (
            <div></div>
            // <div>
            //     {this.state.currentCheckout !== undefined && (
            //     <Card style={{ width: '100%' }}>
            //         <CardHeader>
            //             <h1>Checekout receipt</h1>
            //         </CardHeader>
            //         <CardBody className="px-lg-5 py-lg-5">
            //             <h3>Daftar barang checkout</h3>
            //             <Table className="align-items-center table-flush print-container" responsive>
            //                 <thead>
            //                     <th>Nama produk</th>
            //                     <th>Qty</th>
            //                     <th>Harga</th>
            //                 </thead>
            //                 <tbody>
            //                     {this.state.currentCheckout?.transaction && this.state.currentCheckout.transaction.filter(transaction => transaction).map((transaction) => (
            //                         <tr className="table-borderless">
            //                             <th>
            //                                 {transaction?.product_name}
            //                             </th>
            //                             <td>
            //                                 {transaction?.product_stock}
            //                             </td>
            //                             <td>
            //                                 {transaction.sell_price !== transaction.final_sell_price && (
            //                                     <span>
            //                                         <del><NumberFormat
            //                                             value={transaction.sell_price}
            //                                             displayType={'text'}
            //                                             thousandSeparator={true}
            //                                             prefix={'Rp.'} suffix={',00'} />
            //                                         </del>
            //                                         <br />
            //                                     </span>
            //                                 )}
            //                                 <NumberFormat
            //                                     value={transaction.final_sell_price}
            //                                     displayType={'text'}
            //                                     thousandSeparator={true}
            //                                     prefix={'Rp.'} suffix={',00'} />
            //                             </td>
            //                         </tr>
            //                     ))}
            //                     <tr>
            //                         <th>
            //                             Subtotal
            //                         </th>
            //                         <td></td>
            //                         <td>
            //                             <b><NumberFormat
            //                                 value={this.state.currentCheckout?.subtotal}
            //                                 displayType={'text'}
            //                                 thousandSeparator={true}
            //                                 prefix={'Rp.'} suffix={',00'} />
            //                             </b>
            //                         </td>
            //                     </tr>
            //                     {this.state.currentCheckout?.nik === 0 && (
            //                         <tr className="table-borderless">
            //                             <th>
            //                                 Cash
            //                         </th>
            //                             <td></td>
            //                             <td>
            //                                 <b><NumberFormat
            //                                     value={this.state.currentCheckout?.cashMoney}
            //                                     displayType={'text'}
            //                                     thousandSeparator={true}
            //                                     prefix={'Rp.'} suffix={',00'} />
            //                                 </b>
            //                             </td>
            //                         </tr>
            //                     )}
            //                     {this.state.currentCheckout?.cashChange > 0 && (
            //                         <tr className="table-borderless">
            //                             <th>
            //                                 Kembalian
            //                         </th>
            //                             <td></td>
            //                             <td>
            //                                 <b><NumberFormat
            //                                     value={this.state.currentCheckout?.cashChange}
            //                                     displayType={'text'}
            //                                     thousandSeparator={true}
            //                                     prefix={'Rp.'} suffix={',00'} />
            //                                 </b>
            //                             </td>
            //                         </tr>
            //                     )}
            //                 </tbody>
            //             </Table>
            //             <h3 className="mt-3">Detil checkout</h3>
            //             <Table className="align-items-center table-flush print-container" responsive>
            //                 <tbody>
            //                     <tr>
            //                         <th>Metode Pembayaran</th>
            //                         <td>{this.state.currentCheckout?.nik > 0 ? 'Cashbon' : 'Cash'}</td>
            //                     </tr>
            //                     <tr>
            //                         <th>NIK Pembeli</th>
            //                         <td>{this.state.currentCheckout?.nik > 0 ? this.state.currentCheckout?.nik : '-'}</td>
            //                     </tr>
            //                     <tr>
            //                         <th>Tanggal checkout</th>
            //                         <td>
            //                             {new Date().toLocaleDateString()
            //                                 + ' ' + new Date().toLocaleTimeString()}
            //                         </td>
            //                     </tr>
            //                 </tbody>
            //             </Table>
            //         </CardBody>
            //     </Card>
            // )}
            // <button
            //     className="mt-4 hide-on-print"
            //     color="info"
            //     type="button"
            //     size="sm"
            //     onClick={() => this.handlePrint()}
            //     block>
            //     Cetak</button>
            // </div>
        );
    }
}

export default CheckoutReceipt;